function shortenText(text = '', maxLength = 20) {
  if (text.length < maxLength) return text;

  return text.slice(0, maxLength) + '...';
}

export default shortenText;
